const base = {
  flex: '0 1 100%',
  maxWidth: '100%',
  paddingTop: 's8',
  paddingRight: 's24',
  paddingBottom: 's8'
};

const chart = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const co = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const edu = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const press = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const spark = {
  default: {
    ...base,
    backgroundColor: 'indigo.90'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.90',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const heading = {
  products: {
    chart,
    chartblog: chart,
    co,
    edu,
    press,
    spark
  }
};

export const headingVariants = ['default', 'inverse', 'transparent'];
export type HeadingType = 'default' | 'inverse' | 'transparent';

export default heading;
